export function downloadBlob(blob, filename, mimeType) {
  const blobData = new Blob([blob], { type: mimeType || blob.type });
  const url = window.URL.createObjectURL(blobData);
  const a = document.createElement("a");
  a.style = "display: none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

export function generateInventoryFilename(pluOrAll) {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const date = `${yyyy}${mm}${dd}`;
  const safe = pluOrAll
    ? String(pluOrAll).replace(/[^a-zA-Z0-9.\-_]/g, "-")
    : "all";
  return `inventory-${safe}-${date}.xlsx`;
}
